export function defer(callbackFn: () => void, timeout?: number): void {
  if (timeout) {
    setTimeout(callbackFn, timeout);
  } else {
    callbackFn();
  }
}
